module.exports = __webpack_public_path__ + "img/Icon-card.cf270e16.svg";